export const resetDefaults = {
  resetPassword: "Reset password",
  newPassword: "New password",
  confirmPassword: "Confirm new password",
  returnToLogin: "Return to login",
  gotItButton: "Got it",
  resendButton: "Resend reset link",
  passwordMatchError:
    "Passwords do not match. Please re-enter and confirm your new password.",
  messageResetSuccess: "Password reset successful",
  messageTokenValid: "Token is valid.",
  messageInvalidKeys: "invalid_key",
  messagePasswordReset: "Password reset expired",
  messagePasswordModal:
    "This reset link is no longer valid. You can request a new link below, " +
    "or return to login and use Forgot password.",
  messageWrongError: "Password does not meet the requirements.",
  messageUnauthorizedReset: "Password Reset not authorized.",
  passwordResetRequiredMessage:
    "Password reset required. Enter your username below to receive a new reset link, or use the link from your reset email if you still have it.",
  rules: {
    length: {
      label: "Password must be between 5 and 32 characters",
      isValid: (k) => k.length >= 5 && k.length <= 32,
    },
    characters: {
      label:
        "Must not contain spaces, commas, quotes, colons, semicolon, or slashes",
      isValid: (k) => !/[ ,'":;\/\\]/.test(k),
    },
    match: {
      label: "Password and Confirm Password should Match",
      isValid: (password, confirmPassword) => password === confirmPassword,
    },
  },
};
